<template>
    <div class="form-shape-wrapper">
        <span v-for="(item, index) in formData" :key="index">{{ item }}</span>
    </div>
</template>

<script>
export default {
    name: "FormShape",
    props: ["data"],
    components: {},
    computed: {
        formData() {
            let type = {
                form: "CONTACT US",
                ticket: "MY CASE"
            };

            return this.data.map(item => {
                return type[item.type];
            });
        }
    },
    watch: {},
    methods: {}
};
</script>

<style lang="scss" scoped>
.form-shape-wrapper {
    margin-bottom: 4px;
    text-align: right;

    span {
        display: inline-block;
        border: 1px solid #d8e4f0;
        padding: 6px 6px;
        border-radius: 4px;
        background: #f2f7fb;
    }
}
</style>
